import { type Hotels as HotelsType, type Rates } from '@entities/avail'
import _ from 'lodash'

import { isInternal, isProduction } from '@/config/api'
import { env } from '@/env'

import { CacheAdapter } from '../infra'

export const getCityName = (id: string): string => {
  const cities =
    Object.keys(CacheAdapter.get('cities')).length > 0
      ? CacheAdapter.get('cities')
      : []

  const city = cities.find((c: any) => {
    return Number(c.cityId) === Number(id)
  })

  if (city) {
    const cityName = _.lowerCase(city.cityName)
    return _.upperFirst(
      `${cityName}/${city.stateSymbol} - ${city.countrySymbol}`,
    )
  }

  return ''
}

export function findRate(
  hotel: HotelsType,
  roomTypeIndex: number,
  averageRateIndex: number,
): Rates | undefined {
  return hotel.rates.find(
    (e: Rates) =>
      String(e.id) ===
      String(
        hotel.roomTypes?.[roomTypeIndex]?.averageRates?.[averageRateIndex]
          ?.rateId,
      ),
  )
}

export const isMobile: () => boolean = () => {
  return (
    typeof navigator !== 'undefined' &&
    /Android|webOS|iPhone|iPad|iPod/i.test(navigator.userAgent)
  )
}

export const maskCnpj: (cnpj: string) => string = (cnpj: string) => {
  let cnpjMask = cnpj.replace(/\D/g, '')
  const { length } = cnpjMask

  if (length >= 15) {
    return ''
  }

  if (length > 12) {
    cnpjMask = cnpjMask.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2}).*/,
      '$1.$2.$3/$4-$5',
    )
  } else if (length > 8) {
    cnpjMask = cnpjMask.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{1,2}).*/,
      '$1.$2.$3/$4',
    )
  } else if (length > 5) {
    cnpjMask = cnpjMask.replace(/^(\d{2})(\d{3})(\d{1,3}).*/, '$1.$2.$3')
  } else if (length > 2) {
    cnpjMask = cnpjMask.replace(/^(\d{2})(\d{1,3}).*/, '$1.$2')
  } else {
    cnpjMask = cnpjMask.replace(/^(\d*)/, '$1')
  }

  return cnpjMask
}

export function blobToBase64(
  blob: Blob | null,
  cb: (value: string | null) => void,
): void {
  if (!blob) return

  const reader = new FileReader()
  reader.readAsDataURL(blob)
  reader.onloadend = () => {
    const base64data = reader.result
    let fileContent

    if (typeof base64data === 'string') {
      fileContent = base64data.split('base64,')[1]
    } else if (base64data instanceof ArrayBuffer) {
      const buffer = new Uint8Array(base64data)
      const binary = buffer.reduce(
        (acc, byte) => acc + String.fromCharCode(byte),
        '',
      )
      fileContent = window.btoa(binary).split('base64,')[1]
    } else {
      fileContent = null
    }

    cb(fileContent)
  }
}

export function emailIsValid(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export function upperFirst(str?: string): string {
  if (!str) return ''

  return _.upperFirst(String(str).toLowerCase())
}

export const agencySalePointImagePath = isProduction
  ? env.REACT_APP_AGENCY_SALE_POINT_IMAGES_URL_PROD
  : isInternal
    ? env.REACT_APP_AGENCY_SALE_POINT_IMAGES_URL_PROD
    : env.REACT_APP_AGENCY_SALE_POINT_IMAGES_URL
